import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "inner" }
const _hoisted_3 = { class: "col1" }
const _hoisted_4 = {
  key: 0,
  class: "col2"
}
const _hoisted_5 = { class: "keyBlock" }

import {
  ServiceStatusKeyBlock,
  ScrollToTop,
  ExploreMapButton,
  RouteSearchMap,
  DownloadApp,
  ServiceStatusHome,
  LatLng,
  RouteServiceStatus,
  GoogleMapsRoute,
} from '@components';
import { useRoutesStore, useServiceStatusStore } from '@components/stores';
import {
  computed, onMounted, onUnmounted, ref, watchEffect,
} from 'vue';
import { useRouter } from 'vue-router';
import config from '@/config';
import ModalOverlay from './Modal/ModalOverlay.vue';
import ServiceMapOverlay from './Overlay/ServiceMapOverlay.vue';
import { smsAlertSignupUrl, mobileAppDownloadUrl } from '../envVariables';

const POLLING_INTERVAL_MS = 60000; // 1 min polling

export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceStatus',
  setup(__props) {

const serviceStatusStore = useServiceStatusStore();
const routesStore = useRoutesStore();

const router = useRouter();
const hasSearchResults = ref(false);
const showServiceStatusModal = ref(false);
const showRouteMapModal = ref(false);
const routeMapData = ref<GoogleMapsRoute[] | undefined>(routesStore.getMapRoutesWithStatus);
const portsMapData = ref(routesStore.getMapLocationsWithStatus);
const centreMapData = ref<LatLng>({ lat: 55.609867, lng: -4.958157 });
const mapSearchResults = ref<Array<RouteServiceStatus>>();

const isMapVisible = ref(false);
const { mapPlaceholderImage } = config;

const toggleMapVisibility = () => {
  isMapVisible.value = !isMapVisible.value;
};

const routeToRouteItem = (routeCode) => {
  router.push({ name: 'serviceStatusItem', params: { routeCode } });
};

const showScrollToTop = computed(
  () => !serviceStatusStore.isServiceStatusError && !hasSearchResults.value,
); // Show when no search results showing ONLY per designs

const displayModal = () => {
  showServiceStatusModal.value = true;
  document.querySelector('html')?.classList.add('stopScroll');
  document.querySelector('body')?.classList.add('darkOverlay');
};

const closeModal = () => {
  showServiceStatusModal.value = false;
  document.querySelector('html')?.classList.remove('stopScroll');
  document.querySelector('body')?.classList.remove('darkOverlay');
};

watchEffect(() => {
  if (routesStore.getMapLocationsWithStatus) {
    portsMapData.value = routesStore.getMapLocationsWithStatus;
  }
  if (routesStore.getMapRoutesWithStatus) {
    routeMapData.value = routesStore.getMapRoutesWithStatus;
  }
});

const stopStatusUpdateFns: (() => void)[] = [];

onMounted(async () => {
  document.querySelector('html')?.classList.add('removeOverflow');
  document.querySelector('body')?.classList.add('removeOverflow');

  const stopServiceStatusFetch = await serviceStatusStore.getServiceStatus(POLLING_INTERVAL_MS);
  stopStatusUpdateFns.push(stopServiceStatusFetch);
  const stopRoutesUpdateFetch = await routesStore.requestRoutesWithStatus(POLLING_INTERVAL_MS);
  stopStatusUpdateFns.push(stopRoutesUpdateFetch);

  if (router.currentRoute.value.name === 'serviceStatusMap') {
    showRouteMapModal.value = true;
  }
});

onUnmounted(() => {
  document.querySelector('html')?.classList.remove('removeOverflow');
  document.querySelector('body')?.classList.remove('removeOverflow');
  stopStatusUpdateFns.forEach((fn) => fn());
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["serviceStatusIndex", { dataError: _unref(serviceStatusStore).isServiceStatusError }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('Service Status')), 1),
          _createVNode(_unref(ServiceStatusHome), {
            "status-modal-click-handler": () => displayModal(),
            "select-route-map-callback": () => (showRouteMapModal.value = true),
            "update-route-map-callback": (results) => (mapSearchResults.value = results),
            onGetSelectedRouteCode: _cache[0] || (_cache[0] = (routeCode) => routeToRouteItem(routeCode)),
            onGetHasSearch: _cache[1] || (_cache[1] = (hasSearch) => (hasSearchResults.value = hasSearch))
          }, null, 8, ["status-modal-click-handler", "select-route-map-callback", "update-route-map-callback"]),
          (showScrollToTop.value)
            ? (_openBlock(), _createBlock(_unref(ScrollToTop), { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        (!_unref(serviceStatusStore).isServiceStatusError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (!isMapVisible.value)
                ? (_openBlock(), _createBlock(_unref(ExploreMapButton), {
                    key: 0,
                    "on-click": toggleMapVisibility,
                    "has-placeholder-image": true,
                    "image-src": _unref(mapPlaceholderImage),
                    "image-alt": _ctx.$t('Map placeholder image alt')
                  }, null, 8, ["image-src", "image-alt"]))
                : _createCommentVNode("", true),
              (isMapVisible.value)
                ? (_openBlock(), _createBlock(_unref(RouteSearchMap), {
                    key: 1,
                    center: centreMapData.value,
                    ports: portsMapData.value,
                    routes: routeMapData.value,
                    "search-results": mapSearchResults.value,
                    "is-status-map": true,
                    onOnRouteItemClick: _cache[2] || (_cache[2] = (routeCode) => routeToRouteItem(routeCode))
                  }, null, 8, ["center", "ports", "routes", "search-results"]))
                : _createCommentVNode("", true),
              _createVNode(_unref(DownloadApp), {
                "alert-link": _unref(smsAlertSignupUrl),
                "alert-link-text": _ctx.$t('Download App alert link text'),
                "download-link": _unref(mobileAppDownloadUrl),
                "download-link-text": _ctx.$t('Download App link text'),
                "image-src": require('@images/downloadAppImage.png'),
                "image-alt": _ctx.$t('Download app image alt'),
                title: _ctx.$t('Download App title'),
                text: _ctx.$t('Download App text'),
                class: "showDesktop"
              }, null, 8, ["alert-link", "alert-link-text", "download-link", "download-link-text", "image-src", "image-alt", "title", "text"]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_unref(ServiceStatusKeyBlock), {
                  title: _ctx.$t('Key')
                }, null, 8, ["title"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_unref(ExploreMapButton), {
          "on-click": () => (showRouteMapModal.value = true)
        }, null, 8, ["on-click"])
      ])
    ]),
    _createVNode(ModalOverlay, {
      "is-open": showServiceStatusModal.value,
      "show-close-btn": true,
      "close-callback": () => closeModal()
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(ServiceStatusKeyBlock), {
          title: _ctx.$t('Key')
        }, null, 8, ["title"])
      ]),
      _: 1
    }, 8, ["is-open", "close-callback"]),
    (routeMapData.value && portsMapData.value)
      ? (_openBlock(), _createBlock(ServiceMapOverlay, {
          key: 0,
          "is-open": showRouteMapModal.value,
          "close-callback": () => (showRouteMapModal.value = false),
          center: centreMapData.value,
          ports: portsMapData.value,
          routes: routeMapData.value,
          onRouteItemClick: _cache[3] || (_cache[3] = (routeCode) => routeToRouteItem(routeCode))
        }, null, 8, ["is-open", "close-callback", "center", "ports", "routes"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})